import { config } from '../components/constants.js';

const url = config.url.API_URL;

export async function dismissTeacherAccessWelcome() {
  const response = await fetch(`${url}/users/preferences`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ teacherAccessWelcomePending: false }),
  });

  if (!response.ok) {
    throw new Error('Unable to dismiss teacher welcome.');
  }
}
